import { memo } from 'react'
import { Button, styled, Typography } from '@mui/material'
import { ArrowIOSIcon, StationsIcon, VitrineIcon } from '$common/icons'
import { VitrineWappPanel } from '$logic/wapp-panels'
import { useRoomIsMookeb } from '$logic/hall/react-hook'
import { t } from '$i18n'

const StyledButton = styled(Button)`
  /* @noflip */
  padding: 0 12px 0 8px;
  /* @noflip */
  right: 6px;
`

interface ContainerProps {
  offset: number
}

const Container = styled(StyledButton)<ContainerProps>(({ theme, offset }) => ({
  direction: 'rtl',
  position: 'absolute',
  height: '48px',
  top: offset ? `${offset + 6}px` : '6px',
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: '24px',
  backgroundColor: theme.palette.secondary.light,
  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.2)',
  '&:hover': {
    backgroundColor: theme.palette.secondary.light,
  },
  zIndex: 2,

  '&[data-is-mookeb="true"]': {
    border: `1px solid #00000026`,
    backgroundColor: theme.palette.secondary500,

    '& > span, & > svg': {
      color: theme.palette.neutral900,
    },
  },
}))

const StyledStationsIcon = styled(StationsIcon)`
  width: 20px;
  height: 20px;

  /* @noflip */
  margin-left: 4px;
`

const StyledVitrineIcon = styled(VitrineIcon)`
  width: 20px;
  height: 20px;

  /* @noflip */
  margin-left: 4px;
`

const StyledTypography = styled(Typography)`
  /* @noflip */
  margin-left: 4px;
`

export const ChannelVitrineButton = memo(
  ({
    roomId,
    expanded,
    offset,
  }: {
    roomId: string
    expanded: boolean
    offset?: number
  }) => {
    const { roomIsMookeb, loading } = useRoomIsMookeb(roomId)
    if (loading) return null

    return (
      <Container
        offset={offset || 0}
        data-is-mookeb={roomIsMookeb}
        onClick={() =>
          VitrineWappPanel.open({ roomId, isMookeb: roomIsMookeb })
        }
      >
        {roomIsMookeb ? <StyledStationsIcon /> : <StyledVitrineIcon />}

        {expanded && (
          <StyledTypography color="secondary" variant="subtitle3">
            {t('chat.vitrine')}
          </StyledTypography>
        )}

        <ArrowIOSIcon sx={{ color: 'gray', width: '20px', height: '20px' }} />
      </Container>
    )
  },
)
